import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HttpModule } from '@angular/http';

import { AppService } from './services/app.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpModule,
    NgbModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule
  ],
  declarations: []
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts